export default __webpack_public_path__ + "static/media/TasRacing.d90da044.svg";